import React, { useState } from 'react';
import './HamburgerNav.css'; // Correct path to the CSS file
import { faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const HamburgerMenu = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <div className="hamburger-nav">
            {/* Hamburger Icon */}
            <div
                className={`hamburger-icon ${menuOpen ? 'open' : ''}`}
                onClick={toggleMenu}
            >
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
            </div>

            {/* Menu */}
            <ul className={`menu ${menuOpen ? 'show' : 'hide'}`}>
                <button className="close-btn" onClick={toggleMenu}>
                    <FontAwesomeIcon icon={faX} />
                </button>
                <li><a href="#campus-board" id="home-link" aria-label="Scroll to the top of the page">Home</a></li>
                <li><a href="#studentGrades">Grades</a></li>
                <li><a href="#assignmentsTitle">Assignments</a></li>
            </ul>
        </div>
    );
};

export default HamburgerMenu;
